import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { ShareService } from 'src/app/core/services/share.service';
import { ContactService } from 'src/app/core/services/contact.service';
import { UserService } from 'src/app/core/services/user.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { CalendarService } from 'src/app/core/services/calendar.service';

/** Nombre del tipo de contacto que requiere PDF de cotización */
const TYPE_CONTACT_COTIZACION_NAME = 'Correo Electrónico (Cotización)';

@Component({
  selector: 'app-new-visit-modal',
  templateUrl: './new-visit-modal.component.html',
  styleUrls: ['./new-visit-modal.component.css']
})
export class NewVisitModalComponent implements OnInit {

  @ViewChild('visitPdfInput') visitPdfInput: ElementRef<HTMLInputElement>;

  title: string;
  dataJson = [];
  contact = [];
  isEditable: boolean = true;

  contactList = [];
  partnerList = [];
  timeDayList = [];
  typeContactList = [];

  /** URL del PDF ya subido (cuando la visita ya tiene archivo). */
  visitPdfUrl: string | null = null;
  /** Nombre del archivo PDF (viene del backend, ej. dataJson.visitPdf). */
  visitPdfFileName: string | null = null;
  formSubmitted = false;

  newVisit = new FormGroup({
    date: new FormControl(null, { validators: Validators.required }),
    contactIds: new FormControl(null, { validators: Validators.required }),
    partner: new FormControl(null),
    time: new FormControl(null, [Validators.required]),
    type: new FormControl(null, { validators: Validators.required }),
    summary: new FormControl(null, { validators: Validators.required }),
    visitPdf: new FormControl(null),
  });

  constructor(
    private shareService: ShareService,
    private contactService: ContactService,
    private userService: UserService,
    private notificationService: NotificationService,
    private calendarService: CalendarService,
    public dialogRef: MatDialogRef<NewVisitModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NewVisitModalComponent) {
    this.title = data.title;
    this.dataJson = data.dataJson;
    this.contact = data.contact;
    // ver si se debe agregar la edición.
    if (data.isEditable != undefined && data.isEditable != null) {
      this.isEditable = data.isEditable;
      this.newVisit = new FormGroup({
        date: new FormControl({ value: null, disabled: true }, { validators: Validators.required }),
        contactIds: new FormControl({ value: null, disabled: true }, { validators: Validators.required }),
        partner: new FormControl({ value: null, disabled: true }),
        time: new FormControl({ value: null, disabled: true }, [Validators.required]),
        type: new FormControl({ value: null, disabled: true }, { validators: Validators.required }),
        summary: new FormControl({ value: null, disabled: true }, { validators: Validators.required }),
        typeClient: new FormControl({ value: null, disabled: true }, { validators: Validators.required }),
        visitPdf: new FormControl(null),
      });
    }

  }

  ngOnInit() {
    this.shareService.getVisitTime().subscribe(
      response => {
        this.timeDayList = response;
      },
      error => {
      }
    )

    this.shareService.getVisitType().subscribe(
      response => {
        this.typeContactList = response;
      },
      error => {
      }
    )

    this.shareService.getPartner().subscribe(
      response => {
        this.partnerList = response;
        //console.log(response)
      },
      error => {

      }
    )

    this.contactList = this.contact;

    if (this.dataJson != null) {
      let contactIds = [];
      const contacts = this.dataJson['contact'];
      if (Array.isArray(contacts)) {
        contacts.forEach((c) => contactIds.push(c.id));
      } else if (contacts && typeof contacts === 'object' && contacts.id != null) {
        contactIds = [contacts.id];
      }

      this.newVisit.controls['date'].setValue(this.dataJson['date']);
      this.newVisit.controls['contactIds'].setValue(contactIds);

      if (this.dataJson['partner'] == null) {
        this.newVisit.controls['partner'].setValue(null);
      } else {
        this.newVisit.controls['partner'].setValue(this.dataJson['partner']['id']);
      }

      this.newVisit.controls['time'].setValue(this.dataJson['time']['id']);
      this.newVisit.controls['type'].setValue(this.dataJson['type']['id']);
      this.newVisit.controls['summary'].setValue(this.dataJson['summary']);
      if (!this.isEditable) {
        this.newVisit.controls['typeClient'].setValue((this.dataJson['client']['status'] == 1) ? 'Cliente' : 'Prospecto');
      }
      this.visitPdfUrl = this.dataJson['visitPdfUrl'] || this.dataJson['attachmentUrl'] || null;
      const name = this.dataJson['visitPdf'];
      this.visitPdfFileName = (typeof name === 'string' && name) ? name : (this.dataJson['visitPdfFileName'] || null);
    }

    this.updateVisitPdfValidators();
    this.newVisit.controls['type'].valueChanges.subscribe(() => this.updateVisitPdfValidators());
  }

  /** True cuando el tipo de contacto seleccionado es "Correo Electrónico (Cotización)". */
  get showVisitPdf(): boolean {
    const typeId = this.newVisit.controls['type'].value;
    if (typeId == null) return false;
    const found = this.typeContactList.find((t) => t.id === typeId);
    return found ? found.name === TYPE_CONTACT_COTIZACION_NAME : false;
  }

  private updateVisitPdfValidators(): void {
    const control = this.newVisit.get('visitPdf');
    if (!control) return;
    if (this.showVisitPdf && !this.visitPdfUrl) {
      control.setValidators([Validators.required]);
    } else {
      control.clearValidators();
    }
    control.updateValueAndValidity();
  }

  triggerVisitPdfInput(): void {
    this.visitPdfInput?.nativeElement?.click();
  }

  onVisitPdfChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input?.files?.[0];
    if (file) {
      const isPdf = file.type === 'application/pdf' || (file.name || '').toLowerCase().endsWith('.pdf');
      if (!isPdf) {
        this.notificationService.openSnackBar('Solo se permiten archivos PDF.');
        this.newVisit.controls['visitPdf'].setValue(null);
        input.value = '';
        return;
      }
      this.newVisit.controls['visitPdf'].setValue(file);
    } else {
      this.newVisit.controls['visitPdf'].setValue(null);
    }
  }

  onDownloadVisitPdf(): void {
    if (!this.visitPdfUrl) return;
    let filename = this.visitPdfFileName && this.visitPdfFileName.trim() ? this.visitPdfFileName.trim() : 'cotizacion-visita.pdf';
    if (!filename.toLowerCase().endsWith('.pdf')) filename += '.pdf';
    filename = filename.replace(/-[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}(?=\.pdf$)/i, '');
    this.calendarService.getBlob(this.visitPdfUrl).subscribe(
      (blob: Blob) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(url);
      },
      () => {
        this.notificationService.openSnackBar('No se pudo descargar el PDF. Verifica tu sesión o intenta de nuevo.');
      }
    );
  }

  onConfirm() {
    this.formSubmitted = true;
    const visitPdfFile = this.newVisit.controls['visitPdf'].value;
    if (this.showVisitPdf && !this.visitPdfUrl && !(visitPdfFile instanceof File)) {
      this.notificationService.openSnackBar('El archivo PDF es obligatorio cuando el tipo de contacto es Correo Electrónico (Cotización).');
      return;
    }

    if (this.dataJson != null && this.dataJson['date'] != null) {
      // es para Editar y Actualizar DATA
      if (this.isEditable) {
        if (this.newVisit.valid) {
          this.buildDateAndClose(false, visitPdfFile);
        }
      }
    } else {
      // Es para Crear una visita
      if (this.newVisit.controls['time'].value == 1) {
        let date = moment(this.newVisit.controls['date'].value).utc().format('YYYY-MM-DD') + 'T05:00:00';
        this.newVisit.controls['date'].setValue(date);
      } else if (this.newVisit.controls['time'].value == 2) {
        let date = moment(this.newVisit.controls['date'].value).utc().format('YYYY-MM-DD') + 'T18:00:00';
        this.newVisit.controls['date'].setValue(date);
      } else if (this.newVisit.controls['time'].value == 3) {
        let date = moment(this.newVisit.controls['date'].value).utc().format('YYYY-MM-DD') + 'T00:00:00';
        this.newVisit.controls['date'].setValue(date);
      }

      if (this.newVisit.valid) {
        this.buildDateAndClose(true, visitPdfFile);
      }
    }
  }

  private buildDateAndClose(hasNew: boolean, visitPdfFile: File | null): void {
    if (this.newVisit.controls['time'].value == 1) {
      let date = moment(this.newVisit.controls['date'].value).utc().format('YYYY-MM-DD') + 'T05:00:00';
      this.newVisit.controls['date'].setValue(date);
    } else if (this.newVisit.controls['time'].value == 2) {
      let date = moment(this.newVisit.controls['date'].value).utc().format('YYYY-MM-DD') + 'T18:00:00';
      this.newVisit.controls['date'].setValue(date);
    } else if (this.newVisit.controls['time'].value == 3) {
      let date = moment(this.newVisit.controls['date'].value).utc().format('YYYY-MM-DD') + 'T00:00:00';
      this.newVisit.controls['date'].setValue(date);
    }
    const data = this.newVisit.getRawValue();
    delete data.visitPdf;
    const response = {
      data,
      status: true,
      hasNew,
      delete: false,
      visitPdfFile: visitPdfFile instanceof File ? visitPdfFile : null
    };
    this.dialogRef.close(response);
  }

  onDismiss(): void {
    let response = { data: null, status: false }
    this.dialogRef.close(response);
  }

}
/**
 * Class to represent confirm dialog model.
 *
 * It has been kept here to keep it as part of shared component.
 */
export class NewProspectusModalModel {

  constructor(public title: string, public dataJson: Array<any>, public contact: Array<any>, public isEditable: boolean = true) {
  }
}